export interface IPriorTotals {
    miles: number,
    carServiceTrain: number,
    meals: number,
    dependentCare: number,
    der: number,
    caregiverLodging: number,
    caregiverMeals: number,
    caregiverTransportation: number,
    caregiverFlight: number,
    caregiverDependentCare: number,
    caregiverTotal: number
}